module.exports = __webpack_public_path__ + "static/media/MoreWaysToEarnRefive.10401bca.png";